<div class="documentBox">
  


  <div Id="document" class="documents" [ngClass]="{ list: true, grid: false }">
    <mat-accordion  [multi]="true">

      <ng-container *ngFor="let folder of FormFolderReportList; let i = index">

        <mat-expansion-panel  [expanded]="step === i"  disabled="false" (click)="togglePanels(i)">
          <mat-expansion-panel-header>
            <mat-panel-title class="header">
              <div class="titleCount">
                <div class="folderName">
                  {{ folder.folderName }}
                  <span class="count">{{ folder.forms.length }}</span>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="documentcontainer">        
                    

            <div  class="categories">

              <ul>               

                <li *ngFor="let document of folder.forms;let j=index">
                  <div >

                    <div>             
                  
                      <div class="documentList">
                   
                        <div class="typename">
                          <span class="type">                           
                            <app-doc-icons [iconType]="'HTML'"></app-doc-icons>
                          </span>     

                          <span>
                            {{ document.formName }}
                          </span>
                        </div>

                       


                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="docactions">
            <button mat-icon-button matTooltip="View Report" (click)="openHtmlData(ViewDocument,folder)"
              matTooltipClass="tooltip">
              <mat-icon>report</mat-icon>
            </button>
  
          </div>
        </mat-expansion-panel>

       
      </ng-container>

    </mat-accordion>
  </div>

</div>



<app-loader></app-loader>